import { render, staticRenderFns } from "./buyerRecord.vue?vue&type=template&id=176f2283&scoped=true"
import script from "./buyerRecord.vue?vue&type=script&lang=js"
export * from "./buyerRecord.vue?vue&type=script&lang=js"
import style0 from "./buyerRecord.vue?vue&type=style&index=0&id=176f2283&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176f2283",
  null
  
)

export default component.exports